import React, { Component } from 'react';
import ReactExport from "react-export-excel";
import Moment from 'moment';
import axios from 'axios';
import {API_URL} from '../../../constants';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class LogExcel extends Component {
    
    constructor(props)
    {
        super(props);
    }

    props = {
        dataReport: []
      }

    render() {
        return (
            <ExcelFile filename="LOG" element={<a href="#" className="btnReporte_Log">REPORTE</a>}>
                <ExcelSheet data={this.props.dataReport} name="LOG">
                    <ExcelColumn label="CÓDIGO DE ERROR" value="log_CodigoError"/>
                    <ExcelColumn label="SECCIÓN ORIGEN" value="log_SeccionOrigen"/>                    
                    <ExcelColumn label="MÉTODO" value="log_ClaseFuncion"/>   
                    <ExcelColumn label="COMENTARIO" value="log_Comentario"/>   
                    <ExcelColumn label="IP" value="log_IpCreacion"/>   
                    <ExcelColumn label="FECHA DE REGISTRO" value={(col) => Moment(col.log_FechaCreacion).format('DD/MM/YYYY')}/>                        
                </ExcelSheet>
            </ExcelFile>
        )
    }
}
